import "./legal-footer.css";

import type { OneTrustWindow } from "~/shared/utils/onetrust-types.ts";

import { CcpaImage } from "./ccpa-image.tsx";

type FooterLink = {
	readonly href: string;
	readonly label: string;
};

const FOOTER_LINKS: readonly FooterLink[] = [
	{ href: "https://www.tql.com/", label: "TQL.COM" },
	{ href: "https://www.tql.com/terms", label: "Terms of Use" },
	{ href: " https://www.tql.com/eula-trax", label: "License Agreement" },
	{ href: "https://www.tql.com/privacy", label: "Privacy and Cookies Policy" },
] as const;

// Opens the OneTrust preferences modal exposed by the script loaded in index.html.
function toggleOneTrustInfoDisplay() {
	const w = globalThis as OneTrustWindow;
	w.OneTrust?.ToggleInfoDisplay();
}

export function LegalFooter() {
	const currentYear = new Date().getFullYear();

	return (
		<footer
			aria-label={"TRAX footer"}
			className={"legal-footer"}
			data-testid={"legal-footer"}
		>
			<div className={"legal-footer-content"}>
				<nav aria-label={"Footer legal links"} className={"legal-footer-links"}>
					<ul>
						{FOOTER_LINKS.map((link) => (
							<li key={link.label}>
								<a
									href={link.href}
									rel={"noopener noreferrer"}
									target={"_blank"}
								>
									{link.label}
								</a>
								<span aria-hidden={"true"} className={"legal-footer-separator"}>
									|
								</span>
							</li>
						))}
						<li>
							<button
								className={"legal-footer-privacy-button ot-sdk-show-settings"}
								id={"ot-sdk-btn"}
								onClick={toggleOneTrustInfoDisplay}
								type={"button"}
							>
								Your Privacy Choices
								<CcpaImage
									aria-hidden={"true"}
									className={"legal-footer-ccpa-icon"}
									data-testid={"ccpa-icon"}
									height={14}
									width={30}
								/>
							</button>
							<span aria-hidden={"true"} className={"legal-footer-separator"}>
								|
							</span>
						</li>
						<li className={"legal-footer-copyright"}>
							{`© ${currentYear} Total Quality Logistics, LLC`}
						</li>
					</ul>
				</nav>
			</div>
		</footer>
	);
}
